export default {
  data () {
    return {
      allRouterName: {
        1: { // 丝路情报的
          name: 'report_issue_list',
          id: '1'
        },
        2: { // 智讯参考
          name: 'report_issue_list',
          id: '2'
        },
        3: { // 投资风险周报
          name: 'report_issue_list',
          id: '30'
        },
        4: { // 投资风险报告
          name: 'countryreport_list',
          id: '22'
        },
        5: { // 公共安全报告
          name: 'countryreport_list',
          id: '24'
        },
        6: { // 定制报告
          name: 'report_issue_list',
          id: '13'
        },
        7: { // 专题报告
          name: 'report_issue_list',
          id: '21'
        },
        8: { // 知识产权研究
          name: 'intellectualId'
        }
      }
    }
  },
  methods: {
    gotoDetail (val, type) { // 跳转到
      console.log(val)
      // 研报类里
      val.sourceAsMap.url && (window.location.href = val.sourceAsMap.url)
    }
  }
}
